// import { Avatar, Typography, Tooltip } from 'antd'
// import React from 'react'
// import { ClockCircleFilled } from '@ant-design/icons'
// import { MdCastConnected } from 'react-icons/md'
// import moment from 'moment'
// import { Api } from 'services'
// import { SquareSubIcon } from 'components/subIcon'
// import { IoMdChatbubbles, IoMdVideocam } from 'react-icons/io'
// import { RiWirelessChargingLine } from 'react-icons/ri'
// import { FaGraduationCap } from 'react-icons/fa'
// import Conference  from "Assets/schedule/confrence.svg"
// import Broadcast  from "Assets/schedule/Broadcast.svg"
// import Offline from "Assets/schedule/ofline.svg"
// import UserAvatar from 'components/userAvatar'
// import OtherColor from "Assets/schedule/other_color.svg"

// const { Text } = Typography
// const CancelledClassCard = ({
//   cancelledItem
// }) => {

//   return (
//     <div className="scheduleclass-main">
//       <div style={{ display: 'flex', flexDirection: 'row' }}>
//         <div className="scheduleclass-img-text">
//           <div>
//             <SquareSubIcon icon={cancelledItem?.subject?.icon ? cancelledItem?.subject?.icon : ''} name={cancelledItem?.subject?.name ? cancelledItem?.subject?.name : ''} size={40} />
//           </div>
//           <div style={{ width: '200px', marginLeft: '10px', display: 'flex', flexDirection: 'column' }}>
//             {cancelledItem.mode == "Zoom 40" ?
//               <div style={{ width: '74px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E7F3FF', borderRadius: '8px', padding: '2px' }}>
//                 <IoMdVideocam style={{ color: '#1089FF' }} />
//                 <Text style={{ fontSize: '10px', color: '#1089FF', marginLeft: '5px' }}>Zoom 40</Text>
//               </div>
//               : cancelledItem.mode == "Broadcast" ?
//                 <div style={{ width: '90px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF4D5', borderRadius: '8px', padding: '3px 7px' }}>
//                   <img src={Broadcast} style={{ color: '#FFA931', textAlign: 'center', height: "16px", width: "16px" }} />
//                   <Text style={{ fontSize: '10px', color: '#FFA931', marginLeft: '5px' }}>Broadcast</Text>
//                 </div>
//                 :
//                 cancelledItem.mode == "Conference" ?
//                   <div style={{ width: '90px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '3px 7px'}}>
//                     <img src={Conference} style={{ color: '#594099', height: "16px", width: "16px" }} />
//                     <Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px' }}>Conference</Text>
//                   </div>
//                   :
//                   cancelledItem.mode == 'Others' ?
//                   <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
//                       <img src={OtherColor} style={{ color: '#E50087',height:"16px",width:"16px" }} />
//                       <Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px' }}>Other</Text>
//                   </div>
//                   :
//                   <div style={{ width: '90px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FCF5', borderRadius: '8px', padding: '3px 7px' }}>
//                     <img src={Offline} style={{ color: '#28DF99', textAlign: 'center', height: "16px", width: "16px" }} />
//                     <Text style={{ fontSize: '10px', color: '#28DF99', marginLeft: '5px' }}>Offline</Text>
//                   </div>
//             }
//             <Tooltip title={cancelledItem?.subject?.name ? cancelledItem?.subject?.name : null}>
//               <Text style={{ fontWeight: 'bold', fontSize: '15px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cancelledItem?.subject?.name}</Text>
//             </Tooltip>
//             <div style={{ width: '100%',  display:"flex", flexDirection:"row",alignItems:"center",  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//               <Tooltip title={cancelledItem?.standards.length != 0 ? cancelledItem?.standards?.map((item, index, array) => (`${item?.std + "-" + item?.section}${index === array.length - 1 ? '' : ' | '}`)) : null}>
//                 <FaGraduationCap style={{ color: 'purple', marginRight: '5px' }} />
//               </Tooltip>
//               {cancelledItem?.standards.length != 0 ? cancelledItem?.standards?.map((item, index, array) => (
//                 <Text style={{ fontSize: '80%', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} key={index}>{item?.std + "-" + item?.section}{index === array.length - 1 ? '' : ' |'}</Text>
//               )) : null}
//             </div>
//           </div>
//         </div>
//       </div>
//       <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
//         <div style={{ display:"flex", flexDirection:"row", alignItems:"center", width: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//           <UserAvatar size="small" shape="circle" name={cancelledItem?.teacher?.name} img={cancelledItem?.teacher?.image == "default.png" ? "" : `${Api._s3_url}${cancelledItem?.teacher?.image}`} />
//           <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{cancelledItem?.teacher?.name}</Text>
//         </div>
//         <div>
//           <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
//           <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(cancelledItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(cancelledItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}</Text>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CancelledClassCard


import { Typography, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import ScheduleDetailsDrawer from "./ScheduleDetailsDrawer";
import { getSchedulePermissions } from "./schedulePermissions";
import { IoMdVideocam } from "react-icons/io";
import { useHistory } from "react-router-dom";

import { SquareSubIcon } from "components/subIcon";

import Conference from "Assets/schedule/confrence.svg";
import Online from "Assets/schedule/online.svg";
import Offline from "Assets/schedule/offline.svg";
import OtherColor from "Assets/schedule/other_color.svg";

const { Text } = Typography;

const teacherIcon = require("../../Assets/schedule/teacher.svg").default;
const timerIcon = require("../../Assets/schedule/timer.svg").default;

const CancelledClassCard = ({ cancelledItem }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const user = useSelector((state) => state.session?.user);
  const permissions = getSchedulePermissions(user);
  const canAccessDetails = permissions?.canViewModule;
  const history = useHistory();

  useEffect(() => {
    if (
      history.location.state?.scheduleId &&
      (history.location.state?.scheduleId === cancelledItem?.id || history.location.state?.scheduleId === cancelledItem?.scheduleId || history.location.state?.scheduleId === cancelledItem?.occurrenceId) &&
      (history.location.state?.activeTab === 'quizzes' || history.location.state?.activeTab === 'resources')
    ) {
      setDetailsOpen(true);
    }
  }, [history.location.state, cancelledItem.id]);

  const duration = moment.duration(
    moment(cancelledItem?.endTime, "HH:mm:ss").diff(
      moment(cancelledItem?.startTime, "HH:mm:ss")
    )
  );

  return (
    <>
    <div
      className={canAccessDetails ? "scheduleclass-main scheduleclass-main--cancelled clickable" : "scheduleclass-main scheduleclass-main--cancelled"}
      onClick={() => {
        if (canAccessDetails) {
          setDetailsOpen(true);
        }
      }}

      style={{
        position: "relative",
        padding: 16,
        borderRadius: 16,
        background: "transparent",
        cursor: canAccessDetails ? "pointer" : "default",
      }}
    >
      {/* TOP BAR */}
      <div
        style={{
          // Was position:absolute with hand-picked left/right values that had to
          // coincidentally match the card's own padding for this row to line up
          // with the subject icon below it - never quite exact. A normal in-flow
          // row shares that same padding automatically, guaranteeing the two
          // rows start at the same left edge instead of approximating it.
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: 12, color: "#636363" }}>
          {moment(cancelledItem?.startTime, "HH:mm:ss").format("hh:mm A")} -{" "}
          {moment(cancelledItem?.endTime, "HH:mm:ss").format("hh:mm A")}
        </Text>

        {/* MODE PILL — SAME AS SCHEDULED */}
        {cancelledItem.mode === "Zoom 40" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#E7F3FF",
              borderRadius: 16,
              padding: "4px 10px",
            }}
          >
            <IoMdVideocam style={{ color: "#1089FF" }} />
            <Text style={{ fontSize: 10, color: "#1089FF", marginLeft: 5 }}>
              Zoom 40
            </Text>
          </div>
        ) : cancelledItem.mode === "Broadcast" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#E9FFF9",
              border: "1px solid #C8EEE4",
              borderRadius: 16,
              padding: "4px 10px",
            }}
          >
            <img src={Online} style={{ width: 14, height: 14 }} />
            <Text style={{ fontSize: 10, color: "#00A566", marginLeft: 5 }}>
              Online
            </Text>
          </div>
        ) : cancelledItem.mode === "Conference" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F6F4FE",
              borderRadius: 16,
              padding: "4px 10px",
            }}
          >
            <img src={Conference} style={{ width: 14, height: 14 }} />
            <Text style={{ fontSize: 10, color: "#594099", marginLeft: 5 }}>
              Conference
            </Text>
          </div>
        ) : (cancelledItem.mode === "Others" || cancelledItem.mode === "Other") ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FFE5F4",
              borderRadius: 16,
              padding: "4px 10px",
            }}
          >
            <img src={OtherColor} style={{ width: 14, height: 14 }} />
            <Text style={{ fontSize: 10, color: "#E50087", marginLeft: 5 }}>
              Others
            </Text>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#FFD8DA",
              border: "1px solid #FFF5F6",
              borderRadius: 16,
              padding: "4px 10px",
            }}
          >
            <img src={Offline} style={{ width: 14, height: 14 }} />
            <Text style={{ fontSize: 10, color: "#FF414D", marginLeft: 5 }}>
              Offline
            </Text>
          </div>
        )}
      </div>

      {/* MAIN CONTENT */}
      {/* paddingTop: 32 used to reserve room for the position:absolute TOP BAR -
          it's a normal in-flow row now, so it already takes its own space; this
          just needs a visual gap between the two rows. */}
      <div style={{ paddingTop: 12 }}>
        <div style={{ display: "flex", gap: 16 }}>
          {/* SUBJECT ICON */}
          <SquareSubIcon
            icon={cancelledItem?.subject?.icon || ""}
            name={cancelledItem?.subject?.name || ""}
            size={44}
          />

          <div style={{ flex: 1 }}>
            {/* SUBJECT NAME */}
            <Text
              className="truncate-2-lines"
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#1F1F1F",
                marginBottom: 6,
              }}
            >
              {cancelledItem?.subject?.name}
            </Text>

            {/* TEACHER + DURATION */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                fontSize: 13,
                color: "#636363",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                <img src={teacherIcon} style={{ width: 14 }} />
                <Text
                  ellipsis={{ tooltip: cancelledItem?.teacher?.name }}
                  style={{ fontSize: 13, color: "#636363", maxWidth: 120, margin: 0 }}
                >
                  {cancelledItem?.teacher?.name}
                </Text>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <img src={timerIcon} style={{ width: 14 }} />
                <span>{Math.round(duration.asMinutes())} mins</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CLASS / BATCH NAME — FULL WIDTH */}
      <div style={{ marginTop: 16, maxWidth: '100%', overflow: 'hidden' }}>
        {cancelledItem?.standards && cancelledItem.standards.length > 0 ? (
          <Tooltip
            title={cancelledItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
            placement="bottom"
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
              {cancelledItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
            </Text>
          </Tooltip>
        ) : (
          <Tooltip
            title={cancelledItem?.batchName || ""}
            placement="bottom"
            getPopupContainer={(trigger) => trigger.parentElement}
          >
            <Text style={{ fontSize: 12, color: "#636363", display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
              {cancelledItem?.batchName || ""}
            </Text>
          </Tooltip>
        )}
      </div>
    </div>
    {detailsOpen && (
      <ScheduleDetailsDrawer
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        schedule={cancelledItem}
      />
    )}
    </>
  );
};

export default CancelledClassCard;
